import { Component, OnInit } from '@angular/core';
import { PageService } from 'src/app/services/page.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
    pageLoaded: boolean = false;
    loadText: boolean = false;
    loader: boolean = false;
    text;
    screenWidth;
    constructor(private pageService: PageService) {
        this.pageService.loadPageListen().subscribe((resp) => {
            setTimeout(() => {
                this.pageLoaded = true;
            }, 600);
        })
    }

    ngOnInit(): void {
        this.screenWidth = window.innerWidth;
        if (window.location.pathname == '/') {
            this.loader = true;
        } else {
            this.loader = false;
        }
        setTimeout(() => {
            this.loadText = true;
        }, 300);
    }
}
